import React from "react";
import "./StatCard.css";

/**
 * Reusable StatCard component for displaying statistics
 * @param {number|string} value - The stat value to display
 * @param {string} label - The label for the stat
 * @param {string} variant - Color variant: 'total', 'online', 'offline', 'connectivity', 'unread', 'high', 'medium', 'purple'
 * @param {string} className - Additional custom classes
 */
function StatCard({ value, label, variant = "total", className = "" }) {
  return (
    <div className={`stat-card stat-${variant} ${className}`}>
      <div className="stat-card-value">{value}</div>
      <div className="stat-card-label">{label}</div>
    </div>
  );
}

export default StatCard;
